import {branchApiKey} from "config";
export let userId = null;
export let documentType = null;
export let isBranchIdentitySet = false;
export function setCurrentDocTypeForEventTracking(type: string) {
    documentType = type;
}
export function setUserId(id) {
    userId = id;
}
export function loadBranchScript() {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `branch.init('${branchApiKey}');`;
    const head = document.getElementsByTagName("head")[0];
    if (head !== null && head !== undefined) {
        document.head.appendChild(script);
    }
}
const branch = (window as any).branch;
export function logBranchEvent(eventName: string, body: object) {
    branch.logEvent(
        eventName,
        body,
    );

}
export function setBranchIdentity(id: number) {
    if (branch && !isBranchIdentitySet) {
        branch.setIdentity(String(id));
        isBranchIdentitySet = true;
    }
}
export function logoutBranch() {
    if (branch) {
        isBranchIdentitySet = false;
        branch.logout();
    }
}
export default branch ? branch : null;
